// NOTE: Not currently in use but didn't want to delete the file so we can revive later
import { Locales } from '@ratehub/base-ui';

import createBlogTagStaticProps from '../functions/createBlogTagStaticProps';
import withFrenchLocale from '../functions/withFrenchLocale';
import BlogTagPage from '../components/BlogTagPage';


const { getStaticPaths, getStaticProps } = createBlogTagStaticProps({
    locale: Locales.FRENCH,
    fileName: 'blogTagFR', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    path: '/blogue/tag', // Array to determine the url - final result is `/${rootPath.join('/')}`
});

export default withFrenchLocale(BlogTagPage);
export { getStaticPaths, getStaticProps };
